const ACTION_TYPES = {
  ON_TAB_CHANGE: 'ON_TAB_CHANGE',
  REDIRECT_TO_CREATE_TEST_SESSION: 'REDIRECT_TO_CREATE_TEST_SESSION',
  ON_FIELD_CHANGE: 'ON_FIELD_CHANGE',
  ON_SEARCH_CLICK: 'ON_SEARCH_CLICK',
  ON_RESET_CLICK: 'ON_RESET_CLICK',
}

export default ACTION_TYPES;
